<template>
  <nav
    v-if="!isLoading && user"
    class="navbar navbar-expand-lg ruderclub-dark-green"
    style="z-index: 1"
  >
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/dashboard">
        <img src="../../assets/img/club-logo-rund.png" alt="Logo" height="30" />
        <span class="text-ruderclub-orange">Ruderclub Speck-weg</span>
      </router-link>
      <button
        class="navbar-toggler text-light"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto mt-4 mt-lg-0">
          <li class="nav-item me-0 me-lg-2">
            <router-link
              class="p-2 nav-link d-flex btn btn-outline-ruderclub-orange w-100"
              to="/dashboard"
              @click="closeNavbar"
            >
              Dashboard
            </router-link>
          </li>
          <li class="nav-item me-0 me-lg-2">
            <router-link
              class="p-2 nav-link d-flex btn btn-outline-ruderclub-orange w-100"
              to="/rudertechnik"
              @click="closeNavbar"
            >
              Rudertechnik
            </router-link>
          </li>
          <li class="nav-item me-0 me-lg-2">
            <router-link
              class="p-2 nav-link d-flex btn btn-outline-ruderclub-orange w-100"
              to="/training"
              @click="closeNavbar"
            >
              Trainieren
            </router-link>
          </li>
          <li class="nav-item me-0 me-lg-2">
            <button
              type="button"
              @click="oeffneTrainingAnlegenModalComponent"
              class="mt-2 mt-lg-0 d-flex btn btn-outline-ruderclub-orange w-100"
            >
              <i class="material-symbols-outlined me-2">add</i>Training anlegen
            </button>
          </li>
          <li class="nav-item me-0 me-lg-2">
            <button
              type="button"
              @click="oeffneRadioModalComponent"
              class="mt-2 mt-lg-0 d-flex btn btn-outline-ruderclub-orange w-100"
            >
              <i class="material-symbols-outlined">radio</i>
              <span class="ms-2 d-block d-lg-none">Radio</span>
            </button>
          </li>

          <li class="nav-item me-0 me-lg-2" v-if="istAdmin">
            <router-link
              class="mt-2 mt-lg-0 d-flex btn btn-outline-ruderclub-orange w-100"
              to="/aufgaben"
              @click="closeNavbar"
            >
              <i class="material-symbols-outlined">edit_note</i>
              <span class="ms-2 d-block d-lg-none">Aufgaben</span>
            </router-link>
          </li>

          <li class="nav-item me-0 me-lg-2">
            <router-link
              class="mt-2 mt-lg-0 d-flex btn btn-outline-ruderclub-orange w-100"
              to="/einstellungen"
              @click="closeNavbar"
            >
              <i class="material-symbols-outlined">settings</i>
              <span class="ms-2 d-block d-lg-none">Einstellungen</span>
            </router-link>
          </li>

          <li class="nav-item mb-2 mb-md-0">
            <button
              class="mt-2 mt-lg-0 d-flex btn btn-outline-danger w-100"
              @click="logout"
            >
              <i class="material-symbols-outlined me-2">logout</i> Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { onAuthStateChanged, signOut } from "firebase/auth";
import { firebaseAuth, firebaseDb } from "@/main";
import { Collapse } from "bootstrap";
import { doc, onSnapshot } from "firebase/firestore";

export default {
  data() {
    return {
      user: null,
      istAdmin: false,
      isLoading: true, // Neue Variable für Ladezustand
    };
  },
  async mounted() {
    onAuthStateChanged(firebaseAuth, async (user) => {
      this.isLoading = false;
      this.user = user;

      if (user) {
        this.listenForAdminChanges(user.uid);
      } else {
        this.istAdmin = false;
        this.$router.push("/login");
      }
    });
  },
  methods: {
    listenForAdminChanges(userId) {
      const userDocRef = doc(firebaseDb, "benutzer", userId);

      // Echtzeit-Listener für Admin-Status
      onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          this.istAdmin = docSnap.data().istAdmin;
        } else {
          this.istAdmin = false;
        }
      });
    },

    async logout() {
      this.closeNavbar();
      await signOut(firebaseAuth);
      this.$router.push("/");
    },

    oeffneTrainingAnlegenModalComponent() {
      this.closeNavbar();
      this.$root.$refs.trainingseinheitAnlegenModal.open();
    },

    oeffneRadioModalComponent() {
      this.closeNavbar();
      this.$root.$refs.radioModal.open();
    },

    closeNavbar() {
      const navbarCollapse = document.getElementById("navbarNav");
      if (navbarCollapse && navbarCollapse.classList.contains("show")) {
        new Collapse(navbarCollapse).hide();
      }
    },
  },
};
</script>

<style scoped>
.navbar-brand img {
  height: 30px;
}

.navbar {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
}

#navbarNav a.router-link-active {
  background-color: var(--ruderclub-orange) !important;
  color: var(--ruderclub-dark-green) !important;
}
</style>
